import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'
import {
  getHeadPendant,
  buyHeadPendant,
  getLoginUserInfo,
  gameCoinExchangeList
} from '@/api'

@Module({ dynamic: true, store, name: 'PageCommon' })
class PageCommon extends VuexModule {
  /**
   * 用户信息
   */
  userInfo: any = {
    diamond: 0,
    gameCoin: 0
  }
  @Mutation
  setUserInfo(info: any) {
    this.userInfo = info
  }
  @Action
  getUserInfo() {
    getLoginUserInfo().then(res => {
      this.setUserInfo(res.data)
    })
  }

  /**
   * 商城
   */
  shopDataList: any[] = []

  @Mutation
  setShopDataList(list: any[]) {
    this.shopDataList = list
  }
  @Action
  // 获取装扮列表
  async getShopDataList() {
    const filter_data: any[][] = []
    // 根据类型获取商品  1：头像挂件、2：消息气泡框、3：资料皮肤卡、
    getHeadPendant({ pageNum: 1, pageSize: 999 }).then(async res => {
      const data = res.data.list
      if (res.code == 1001 && res.data && data) {
        filter_data[0] = data.filter((item: any) => item.useType === 1)
        filter_data[1] = data.filter((item: any)  => item.useType === 2)
        filter_data[2] = data.filter((item: any)  => item.useType === 3)
        // 4：其他兑换
        await gameCoinExchangeList().then(response => {
          if (response.code === 1001 && response.data) {
            filter_data.push(response.data)
            this.setShopDataList(filter_data)
          }
        })
      }
    })
  }
}

export const PageCommonModule = getModule(PageCommon)
